import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function NotFound({ theme }) {
  const primaryColor   = theme?.primaryColor   || "#6b2118";
  const accentColor    = theme?.accentColor    || "#c9a84c";
  const secondaryColor = theme?.secondaryColor || "#2e7d32";
  const navigate = useNavigate();

  return (
    <div style={{
      paddingTop: 64, minHeight: "100vh",
      background: `linear-gradient(135deg, #2c0f0a 0%, ${primaryColor} 60%, #1a0a05 100%)`,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexDirection: "column", gap: 0, textAlign: "center", padding: "60px 24px",
    }}>
      {/* Animated circles */}
      {[300, 450, 600].map((size, i) => (
        <div key={i} style={{
          position: "absolute", borderRadius: "50%",
          width: size, height: size,
          top: "50%", left: "50%", transform: "translate(-50%,-50%)",
          border: `1px solid rgba(201,168,76,0.1)`,
          animation: `pulse 6s ease-in-out ${i}s infinite`,
          pointerEvents: "none",
        }} />
      ))}

      <div style={{ position: "relative", zIndex: 2 }}>
        <div style={{
          fontFamily: "Georgia, serif",
          fontSize: "clamp(6rem, 20vw, 10rem)",
          fontWeight: 900, color: accentColor,
          lineHeight: 1, marginBottom: 8,
          textShadow: `0 0 60px ${accentColor}40`,
        }}>404</div>

        <h1 style={{
          fontFamily: "Georgia, serif",
          fontSize: "clamp(1.4rem, 4vw, 2.2rem)",
          color: "#fff", marginBottom: 16,
        }}>Page Not Found</h1>

        <p style={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "1rem", marginBottom: 40,
          maxWidth: 400, lineHeight: 1.7,
        }}>
          Looks like this page doesn't exist. Let's get you back to something delicious.
        </p>

        <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: "rgba(255,255,255,0.12)",
              border: "2px solid rgba(255,255,255,0.3)",
              color: "#fff", padding: "13px 28px",
              borderRadius: 40, fontWeight: 700,
              fontSize: "0.9rem", cursor: "pointer",
              letterSpacing: 1,
            }}
          >← Go Back</button>

          <Link to="/" style={{
            background: accentColor,
            color: "#2c1810", padding: "13px 28px",
            borderRadius: 40, fontWeight: 800,
            fontSize: "0.9rem", textDecoration: "none",
            letterSpacing: 1,
          }}>🏠 Home</Link>

          <Link to="/shop" style={{
            background: secondaryColor,
            color: "#fff", padding: "13px 28px",
            borderRadius: 40, fontWeight: 700,
            fontSize: "0.9rem", textDecoration: "none",
            letterSpacing: 1,
          }}>🌾 Shop</Link>
        </div>
      </div>

      <style>{`@keyframes pulse{0%,100%{opacity:.1}50%{opacity:.3}}`}</style>
    </div>
  );
}
